import script from "./InputBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./InputBlock.vue?vue&type=script&setup=true&lang=js"

import "./InputBlock.vue?vue&type=style&index=0&id=64dc83ad&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64dc83ad"]])

export default __exports__